import { DateOnly } from '@if/core/date'
import CalculateIcon from '@mui/icons-material/Calculate'
import { Box, Button, Card, CardActions, CardContent, CircularProgress, Typography } from '@mui/material'
import { BaseWorksheetForm } from '@src/components'
import { BaseWorksheetFormConfig, WorksheetError } from '@src/components/WorksheetForm'
import { Control } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { CalculatorValues } from '../calculatorSchema'

interface CalculatorParametersFormProps {
  control: Control<CalculatorValues>
  config: BaseWorksheetFormConfig
  activationMaxDate: DateOnly
  isComputing: boolean
  isFieldsLoading: boolean
  onLoadingChange?: (isLoading: boolean) => void
  onError?: (errors: WorksheetError[]) => void
  hideSubmitButton?: boolean
}

const CalculatorParametersForm = ({
  control,
  config,
  activationMaxDate,
  isComputing,
  isFieldsLoading,
  onLoadingChange,
  onError,
  hideSubmitButton = false,
}: CalculatorParametersFormProps) => {
  const { t } = useTranslation()

  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="overline" color="text.secondary" gutterBottom>
          {t('calculator.parameters')}
        </Typography>
        <Box>
          <BaseWorksheetForm config={config} onLoadingChange={onLoadingChange} onError={onError}>
            <BaseWorksheetForm.AmountRequested control={control} />
            <BaseWorksheetForm.PaymentPlan control={control} />
            <BaseWorksheetForm.Term control={control} />
            <BaseWorksheetForm.PaymentFrequency control={control} />
            <BaseWorksheetForm.ActivationDate control={control} maxDate={activationMaxDate} />
            <BaseWorksheetForm.FirstPaymentDate control={control} />
            <BaseWorksheetForm.IncludeProtection control={control} />
            <BaseWorksheetForm.IsHighEstimate control={control} />
          </BaseWorksheetForm>
        </Box>
      </CardContent>

      {!hideSubmitButton && (
        <CardActions>
          <Button
            fullWidth
            type="submit"
            variant="contained"
            size="large"
            startIcon={
              isComputing || isFieldsLoading ? <CircularProgress size={16} color="inherit" /> : <CalculateIcon />
            }
            disabled={isComputing || isFieldsLoading}
          >
            {t('calculator.calculate')}
          </Button>
        </CardActions>
      )}
    </Card>
  )
}

export default CalculatorParametersForm
